import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import {
    Checkbox,
    FormControlLabel,
    Popper,
    TextField,
    Typography
} from '@material-ui/core';
import {Autocomplete, createFilterOptions} from '@material-ui/lab';
import Dialog from "@material-ui/core/Dialog";
import {Transition} from "react-transition-group";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
    formControl: {
        width: '100%',
        maxWidth: 'initial'
    },
    popper: {
        maxWidth: 'fit-content'
    }
}));

const processText = (text, fun) => {
    if (text.length > 30) return <div>{text.substring(0, 30)}
        <div
            onClick={() => {
                fun(text)
            }}
        >show more
        </div>
    </div>
    return text
}

const Label = (text, fun) => {
    return <React.Fragment
    >
        {processText(text, fun)}
    </React.Fragment>

}

const PopperMy = (props) => {
    return (
        <Popper {...props} style={useStyles.popper} placement="bottom-start"/>
    );
};

const filterOptions = createFilterOptions({
    matchFrom: 'any',
    limit: 250
});

const AutocompleatableSelect = (props) => {
    const [input, setInput] = useState('');
    const classes = useStyles();
    const [moreText, setMoreText] = useState("");
    const {label, options, selectedOptions, setSelectedOptions, noOptionsText} =
        props;
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
    }, [selectedOptions]);
    return (
        <React.Fragment>
            <Dialog
                open={moreText !== ""}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                        setMoreText("");
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="lg">
                <div className="flex flex-col min-h-80 justify-start items-end">
                <IconButton
                    aria-label="close"
                    onClick={() => setMoreText("")}
                >
                    <CloseIcon/>
                </IconButton>{moreText}</div></Dialog>
            <FormControl className={classes.formControl}>
                <Autocomplete
                    filterOptions={filterOptions}
                    multiple
                    {...(noOptionsText && {noOptionsText: noOptionsText})}
                    value={selectedOptions}
                    clearOnBlur
                    disableCloseOnSelect
                    PopperComponent={PopperMy}
                    options={options}
                    inputValue={inputValue}
                    getOptionLabel={(option) => option}
                    renderOption={(props, option) => (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    style={{color: 'green', margin: 0, padding: 0}}
                                    checked={option.selected}
                                />
                            }
                            label={Label(props, (txt) => {
                                setMoreText(txt)
                            })}
                        />
                    )}
                    onChange={(e, value) => {
                        setSelectedOptions(value);
                        setInputValue('');
                    }}
                    renderTags={(selected) => {
                        selected = selected?.map((s)=>{if(s.length>30) return s.substring(0,30)+"...";else return s;})
                        if(selected.length > 5) {
                            selected = selected.slice(0, 5);
                        }
                        let renderTagsValue = selected.join(',');

                        return (
                            <Typography
                                noWrap={true}
                                color="textPrimary"
                                variant="body1"
                                style={{
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {renderTagsValue}
                            </Typography>
                        );
                    }}
                    renderInput={(params) => {
                        return (
                            <TextField
                                {...params}
                                label={label}
                                onChange={(e) => {
                                    setInputValue(e.target.value);
                                    setInput(e.target.value);
                                }}
                                onKeyDown={(e) => {
                                    if(e.key === 'Enter'){
                                        const toSelect = options.filter((o)=>{
                                            if(o.toLowerCase().includes(input.toLowerCase())){
                                                return o;
                                            }
                                            else{
                                                return false
                                            }
                                        })
                                        setSelectedOptions(toSelect);
                                    }
                                }}
                            />
                        );
                    }}
                />
            </FormControl>
        </React.Fragment>
    );
};

export default AutocompleatableSelect;
